<template>
  <div v-if="relations?.length" :class="$style.root">
    <div :class="$style.label">
      {{ $t('related.label', { title: page?.title }) }}
    </div>
    <coreBoxListComponent>
      <template
        v-for="relation in relationsPaginated"
        :key="relation?.id"
      >
        <i18nLink
          :to="{ name: `${relation.listType}-slug`, params: { slug: relation?.attributes?.slug } }"
          :class="$style.link"
        >
          <coreBoxListItemComponent :class="$style.item">
            <div :class="$style.relationTitle">
              {{ relation?.attributes?.title }}
            </div>
            <span :class="$style.relationLabel">
              {{ $t(`pages.${relation.listType}.label`) }}
            </span>
          </coreBoxListItemComponent>
        </i18nLink>
      </template>
    </coreBoxListComponent>

    <button
      v-if="relations?.length > limit && paginated"
      :class="$style.button"
      @click="paginated = false"
    >
      {{ $t('shared.showAll', { count: relations?.length }) }}
    </button>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  page: object
}>()

const limit = 4
const paginated = ref(true)

const relations = [
  props?.page?.exhibitionEntries?.data?.map((item: any) => { return { ...item, listType: "exhibitions" } })?.filter(Boolean),
  props?.page?.educationEntries?.data?.map((item: any) => { return { ...item, listType: "education" } })?.filter(Boolean),
  props?.page?.projectEntries?.data?.map((item: any) => { return { ...item, listType: "projects" } })?.filter(Boolean),
  props?.page?.journalEntries?.data?.map((item: any) => { return { ...item, listType: "journals" } })?.filter(Boolean),
].filter(Boolean)?.flat()

const relationsPaginated = computed(() => paginated.value ? relations?.slice(0, limit) : relations)
</script>

<style module>
.root {
  composes: container from global;
  margin-top: calc(var(--unit--vertical) * 2);
}

.label {
  composes: font-helvetica font-size-small from global;
  composes: label from global;
}

.relationLabel {
  composes: font-helvetica font-size-small from global;
}

.link {
  composes: reset-link from global;
  display: contents;
}

.link:hover .relationTitle {
  text-decoration-line: underline;
}

.relationTitle {
  composes: font-size-default from global;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  line-height: 1;
  padding-top: .2em;
}

.button {
  composes: reset-button font-helvetica font-size-small link from global;
  margin-top: var(--padding--element--top);
}
</style>
